import { ArrowUpRight } from "lucide-react";

const stats = [
    {
        value: "60 days",
        label: "from idea to live, monetized product",
    },
    {
        value: "9 paying customers",
        label: "acquired through founder-led content",
    },
    {
        value: "$0 ad spend",
        label: "growth driven by build-in-public + organic",
    },
];

export default function EzScribeProof() {
    return (
        <section
            id="proof"
            data-testid="ezscribe-proof-section"
            className="relative py-24 sm:py-32 scroll-mt-nav overflow-hidden border-y border-white/5 bg-[#060d18]"
        >
            <div className="absolute inset-0 grid-bg opacity-30 pointer-events-none" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[640px] h-[640px] rounded-full bg-[#00f0ff]/[0.03] blur-[140px] pointer-events-none" />

            <div className="relative max-w-5xl mx-auto px-6 sm:px-10 lg:px-16 text-center">
                <span className="text-[11px] font-bold uppercase tracking-[0.25em] text-[#00f0ff]">
                    Proof, not promises
                </span>
                <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tighter mt-4 leading-[1.05]">
                    We don&apos;t just build AI apps.{" "}
                    <span className="text-gradient-cyan">We ship them.</span>
                </h2>
                <p className="text-lg text-[#94a3b8] mt-7 max-w-2xl mx-auto leading-relaxed">
                    ezBuildabot is run by the founder of ezScribe — a live AI medical
                    transcription app serving paying customers in clinics across the U.S. The
                    same playbook we used to ship ezScribe in 60 days is the playbook we run
                    for every client.
                </p>

                <div className="mt-14 grid grid-cols-1 sm:grid-cols-3 gap-5">
                    {stats.map((s, i) => (
                        <div
                            key={s.value}
                            data-testid={`proof-stat-${i + 1}`}
                            className="rounded-2xl bg-[#0a1325] border border-white/10 p-8 hover:border-[#00f0ff]/40 transition-colors"
                        >
                            <div className="font-heading text-3xl sm:text-4xl font-black tracking-tighter text-[#00f0ff]">
                                {s.value}
                            </div>
                            <div className="text-sm text-[#94a3b8] mt-3 leading-relaxed">
                                {s.label}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="mt-14 mx-auto max-w-3xl flex flex-col sm:flex-row items-center gap-7 rounded-2xl bg-[#0a1325] border border-white/10 p-7 sm:p-8 text-left">
                    <div className="shrink-0">
                        <img
                            src="https://customer-assets-4nw71qhi.emergentagent.net/job_69f4835c-b463-4215-9789-36847b82cb89/artifacts/hn9o25hz_Headshot.png"
                            alt="Robert, founder of ezBuildABot and ezScribe"
                            data-testid="founder-photo"
                            className="w-28 h-28 sm:w-32 sm:h-32 rounded-2xl object-cover border border-white/10"
                        />
                    </div>
                    <div>
                        <p className="text-lg text-[#cbd5e1] leading-relaxed italic">
                            &ldquo;I don&apos;t pitch AI — I ship it. ezScribe is live, paying the
                            bills, and built with the exact process I&apos;ll run for you.&rdquo;
                        </p>
                        <div className="mt-4">
                            <div className="font-heading text-lg font-bold text-white tracking-tight">
                                Robert
                            </div>
                            <div className="text-sm text-[#94a3b8]">
                                Founder — ezBuildABot, ezScribe &amp; Gadget Guy Media
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-12 flex flex-col items-center gap-5">
                    <a
                        href="https://ezscribe.net"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-testid="proof-cta-ezscribe"
                        className="group inline-flex items-center gap-2 px-7 py-3.5 rounded-lg border border-white/15 text-white hover:border-[#00f0ff] hover:text-[#00f0ff] transition-all duration-300"
                    >
                        See the ezScribe story
                        <ArrowUpRight className="w-4 h-4 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
                    </a>
                    <p className="text-sm italic text-[#64748b] max-w-xl">
                        Every client gets a founder who&apos;s done it — not an agency that&apos;s
                        pitched it.
                    </p>
                </div>
            </div>
        </section>
    );
}
